import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import SiteMeta from './components/SiteMeta';
import PortalGate from './components/PortalGate';
import { AuthProvider } from './lib/auth';

import Home from './pages/Home';
import About from './pages/About';
import Contact from './pages/Contact';
import Blog from './pages/Blog';
import BlogPost from './pages/BlogPost';
import Sales from './pages/Sales';
import Leasing from './pages/Leasing';
import Management from './pages/Management';
import PropertyDetails from './pages/PropertyDetails';
import PropertiesByLocation from './pages/PropertiesByLocation';

import ForgotPassword from './pages/auth/ForgotPassword';
import ResetPassword from './pages/auth/ResetPassword';
import AdminPortal from './pages/Admin';
import OversightPortal from './pages/Oversight';
import ManagerPortal from './pages/Manager';
import StaffPortal from './pages/StaffPortal';
import AccountPortal from './pages/Account';

const INTERNAL_PREFIXES = ['/admin', '/it', '/oversight', '/manager', '/staff', '/accounts', '/account', '/forgot-password', '/reset-password'];

function AccountRedirect() {
  const location = useLocation();
  const sub = location.pathname.replace(/^\/account\/?/, '');
  return <Navigate to={`/accounts/${sub}`} replace />;
}

function Layout() {
  const location = useLocation();
  const isInternal = INTERNAL_PREFIXES.some((p) => location.pathname.startsWith(p));

  return (
    <div className="flex flex-col min-h-screen">
      {!isInternal && <Navbar />}
      <main className="flex-grow">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/sales" element={<Sales />} />
          <Route path="/sales/:code" element={<PropertyDetails />} />
          <Route path="/leasing" element={<Leasing />} />
          <Route path="/leasing/:code" element={<PropertyDetails />} />
          <Route path="/management" element={<Management />} />
          <Route path="/management/:code" element={<PropertyDetails />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/property/:id" element={<PropertyDetails />} />
          <Route path="/properties/:location" element={<PropertiesByLocation />} />

          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />

          <Route path="/admin" element={<PortalGate role="admin"><AdminPortal /></PortalGate>} />
          <Route path="/admin/*" element={<PortalGate role="admin"><AdminPortal /></PortalGate>} />
          <Route path="/oversight" element={<Navigate to="/it" replace />} />
          <Route path="/oversight/*" element={<Navigate to="/it" replace />} />
          <Route path="/it" element={<PortalGate role="oversight"><OversightPortal /></PortalGate>} />
          <Route path="/it/*" element={<PortalGate role="oversight"><OversightPortal /></PortalGate>} />
          <Route path="/manager" element={<PortalGate role="manager"><ManagerPortal /></PortalGate>} />
          <Route path="/manager/*" element={<PortalGate role="manager"><ManagerPortal /></PortalGate>} />
          <Route path="/staff" element={<PortalGate role="staff"><StaffPortal /></PortalGate>} />
          <Route path="/staff/*" element={<PortalGate role="staff"><StaffPortal /></PortalGate>} />
          <Route path="/accounts" element={<PortalGate role="account"><AccountPortal /></PortalGate>} />
          <Route path="/accounts/*" element={<PortalGate role="account"><AccountPortal /></PortalGate>} />
          <Route path="/account/*" element={<AccountRedirect />} />
          <Route path="/account" element={<AccountRedirect />} />
          <Route path="/login/*" element={<Navigate to="/" replace />} />
          <Route path="/login" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
      {!isInternal && <Footer />}
    </div>
  );
}

export default function App() {
  return (
    <Router>
      <AuthProvider>
        <ScrollToTop />
        <SiteMeta />
        <Layout />
      </AuthProvider>
    </Router>
  );
}
